exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".employee-locked-hint[data-v-7a87c65b]{display:block;margin-top:6px;color:#6c757d}.employee-code-error[data-v-7a87c65b]{display:block;margin-top:6px;color:#dc3545}", ""]);

// exports
